/*
 * @Author: edvardchen
 * @Date:   2016-11-23 09:28:44
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-11-15 20:12:05
 */
const SecurityError = 'SecurityError';

const QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

function getItem(target, name) {
  let data;
  try {
    data = target.getItem(name);
  } catch (ignore) {
    return null;
  }
  try {
    return JSON.parse(data);
  } catch (ignore) {
    return null;
  }
}

function setItem(target, key, value) {
  try {
    if (value === undefined || value === null) {
      target.removeItem(key);
    } else if (target) {
      target.setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Storage is not available due to security settings');
      }
      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0) {
      target && target.clear && target.clear(); // 清除缓存防止容量过大
      return;
    }

    throw error;
  }
}

export const sessionStorage = {
  getItem: getItem.bind(undefined, global.sessionStorage),
  setItem: setItem.bind(undefined, global.sessionStorage),
};

export const localStorage = {
  getItem: getItem.bind(undefined, global.localStorage),
  setItem: setItem.bind(undefined, global.localStorage),
};
